import { dialog, InfiniteScroll, printComponent, Progress } from "nq-component";
import BaseListPage from "../../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import CardView from "../../../../components/common/CardView";
import Search from "../../../../components/Search";
import withRouter from "../../../../withRouter";
import { SubmitFormBaseList } from "../../../../components/common/Converter";
import Pagination from "../../../../components/common/Pagination";
import { Spin } from "antd";
import React from "react";
import PrintWithWwaterMark from "./certificatePreview/PrintWithWaterMark";

class MyTrainingPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new SubmitFormBaseList(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      progress: false,
      objects: [],
      currentPage: 1,
      perPage: 10,
      newObj: [],
      count: "",
      loading: true,
    };
    this.contractPDF = React.createRef();
  }
  async componentDidUpdate(prevProps, prevState) {
    if (prevState.objects !== this.state.objects) {
      await this.fetchData();
    }
  }

  formatDate = (date) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(date).toLocaleDateString(undefined, options);
  };

  async fetchData() {
    const user = this.getCurrentUser();

    const allTrainingEntries = await findObjectUseCase().execute(
      "enroll_training",
      { sort: { createdAt: -1 } }
    );
    const isUserRole = user.roles.some((role) => role.id === "user");
    let trainingList;

    try {
      if (!isUserRole) {
        // Filter duplicates based on trainingID
        const trainingMap = new Map();
        allTrainingEntries.forEach((training) => {
          trainingMap.set(training.trainingID, training);
        });
        trainingList = Array.from(trainingMap.values());
      } else {
        trainingList = await findObjectUseCase().execute("enroll_training", {
          where: { empID: user.employee.id },
        });
      }

      this.setState({ newObj: trainingList, count: trainingList.length });
    } catch (error) {
      this.showError("MY Training: ", error);
    } finally {
      this.setState({ loading: false });
    }
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    this.loadObjects();
  }

  // componentDidMount() {
  //   this.loadObjects();
  // }

  async loadObjects() {
    const objects = await findObjectUseCase().execute(this.getCollectionName());
    this.setState({
      objects,
    });
  }

  getCollectionName() {
    return "enroll_training";
  }

  async refetchData() {
    return this.fetchData();
  }

  handlePageChange = (currentPage) => {
    this.setState({ currentPage });
  };

  handlePerPageChange = (perPage) => {
    this.setState({ perPage, currentPage: 1 });
  };

  async searchSubmit(where) {
    const newObj = await findObjectUseCase().execute(this.getCollectionName(), {
      where: where.$or[2],
      sort: { createdAt: -1 },
    });
    this.setState({ newObj });
  }

  showPrintPreview(object) {
    // this.setState({ previewObj: object, isPrinting: true });
    this.setState({ trainingObj: object });
    printComponent(this.contractPDF.current, "Tasks");
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { currentPage, perPage, newObj, loading } = this.state;
    if (!schema) return <Progress />;

    const startIndex = (currentPage - 1) * perPage;
    const paginatedObjects = newObj.slice(startIndex, startIndex + perPage);

    return (
      <>
        <div className="d-none">
          <div ref={this.contractPDF} id="contractPDF">
            <PrintWithWwaterMark object={this.state.trainingObj} />
          </div>
        </div>
        <div className="overflow-auto">
          <CardView style={{ borderRadius: 0 }}>
            <Search
              schemas={this.getSchemas()}
              onSubmit={this.searchSubmit.bind(this)}
              fields={schema.fields}
            />
          </CardView>

          {loading ? (
            <div className="d-flex align-items-center justify-content-center p-5">
              <Spin size="large" />
            </div>
          ) : (
            <div className="mt-4 row w-100 p-0 m-0 d-flex align-items-center justify-content-center">
              {paginatedObjects.map((items, index) => (
                <div className="col-lg-4 mb-5" key={index}>
                  <CardView style={{ borderRadius: 0 }}>
                    <p>
                      <b>{items.training}</b>
                    </p>
                    <div
                      className="d-grid"
                      style={{
                        color: "rgba(0, 0, 0, .45)",
                        fontSize: "12px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "5px",
                        }}
                      >
                        <span
                          style={{
                            display: "inline-block",
                            border: "1px solid blue",
                            backgroundColor: "#edf5fe",
                            borderRadius: "4px",
                            color: "blue",
                            padding: "2px 4px",
                            whiteSpace: "nowrap",
                            width: "auto",
                          }}
                        >
                          {items.stats}
                        </span>
                      </div>
                      <span>
                        <i className="bi bi-calendar" /> {items.date}
                      </span>
                      <span>
                        <i className="bi bi-clock" /> {items.time}
                      </span>
                      <span>
                        Date of submission <i className="bi bi-calendar" /> -
                      </span>
                      <span>
                        Target Competency: test: {items.targetcompetency}
                      </span>
                    </div>
                    <hr />
                    {items.stats === "Done" && (
                      <div className="d-flex align-items-center justify-content-evenly">
                        {/* <div
                        className="w-50 border-end text-center"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleEnrollBtn(items)}
                      >
                        <i className="bi bi-check text-bg-secondary" />
                      </div> */}
                        <div
                          className="w-100 text-center"
                          style={{ cursor: "pointer" }}
                          onClick={() => this.showPrintPreview(items)}
                        >
                          <i className="bi bi-search text-bg-secondary" />
                        </div>
                      </div>
                    )}
                    {/* <div className="d-flex align-items-center justify-content-evenly">
                    <div
                      className="w-50 border-end text-center"
                      style={{ cursor: "pointer" }}
                      onClick={() => this.handleEnrollBtn(items)}
                    >
                      <i className="bi bi-check text-bg-secondary" />
                    </div>
                    <div
                      className="w-50 border-start text-center"
                      style={{ cursor: "pointer" }}
                      onClick={() => this.handleCompletedBtn(items)}
                    >
                      <i className="bi bi-x text-bg-secondary" />
                    </div>
                  </div> */}
                  </CardView>
                </div>
              ))}
            </div>
          )}
        </div>
        <Pagination
          totalObjects={newObj.length}
          onPageChange={this.handlePageChange}
          onPerPageChange={this.handlePerPageChange}
        />

        {/* {this.state.isPrinting && (
          <CertificatePreview
            object={this.state.previewObj}
            formattedDate={this.formatDate(new Date())}
            onClose={() => this.setState({ isPrinting: false })}
          />
        )} */}
      </>
    );
  }
}

export default withRouter(MyTrainingPage);
